import type { FunctionComponent } from "react";

interface IconArticleProps {
  color?: string;
}

const IconArticle: FunctionComponent<
  IconArticleProps
> = ({ color = "#000000" }) => {
  return (
    <svg
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0705 19.312L9.61182 20.4746L10.6883 13.9298L23.0243 1.63682C23.2244 1.43503 23.4625 1.27487 23.7249 1.16557C23.9872 1.05627 24.2686 1 24.5528 1C24.8371 1 25.1184 1.05627 25.3808 1.16557C25.6431 1.27487 25.8813 1.43503 26.0814 1.63682L28.3635 3.91888C28.5652 4.11902 28.7254 4.35713 28.8347 4.61948C28.944 4.88183 29.0003 5.16322 29.0003 5.44743C29.0003 5.73163 28.944 6.01303 28.8347 6.27538C28.7254 6.53773 28.5652 6.77584 28.3635 6.97598L16.0705 19.312Z"
        stroke={color}
        style={{
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
      <path
        d="M25.7582 20.3886V26.8472C25.7582 27.4182 25.5314 27.9658 25.1276 28.3696C24.7239 28.7733 24.1763 29.0001 23.6053 29.0001H3.15289C2.58191 29.0001 2.03431 28.7733 1.63057 28.3696C1.22682 27.9658 1 27.4182 1 26.8472V6.39483C1 5.82385 1.22682 5.27625 1.63057 4.87251C2.03431 4.46876 2.58191 4.24194 3.15289 4.24194H9.61154"
        stroke={color}
        style={{
          strokeWidth: "1.8",
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
      />
    </svg>
  );
};

export default IconArticle;
